import { HttpClient } from '@angular/common/http';


export class ScaffoldApiService<TModel, TQueryModel> {

    constructor(private httpClient: HttpClient, private fnName: string) {

    }

    public get(id: string) {
        return this.httpClient.get<TModel>(`api/${this.fnName}/${id}`)
    }

    public getAll() {
        return this.httpClient.get<TModel[]>(`api/${this.fnName}`)

    }

    public create(model: TModel) {
        return this.httpClient.post<TModel>(`api/${this.fnName}`, model);
    }

    public update(model: TModel) {
        return this.httpClient.put<TModel>(`api/${this.fnName}`, model);
    }

    public delete(id: string) {
        return this.httpClient.delete(`api/${this.fnName}/${id}`);
    }

    public query(queryModel: TQueryModel) {

        const params: { [key: string]: string } = {};
        Object.keys(queryModel).forEach(key => {
            params[key] = `${queryModel[key]}`;
        })
        return this.httpClient.get(`api/${this.fnName}/query`, { params: params })
    }


}